import {connect} from "react-redux";
import TranchesReleaseRequest from "./TranchesReleaseRequest";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../services/redux/fileUpload/action";
import {
    loanAccountRequest,
    loanTranchesRequest,
    loanApplicationByIdRequest,
    loanApprovalRequestRequest,
    updateTrancheStatusRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    loanAccountResponse: state.CarLoan.loanAccountResponse,
    ucdCaseByIdResponse: state.CarLoan.loanApplicationByIdResponse,
    loanTranchesResponse: state.CarLoan.loanTranchesResponse,
    loanApprovalRequestResponse: state.CarLoan.loanApprovalRequestResponse,
    updateTrancheStatusResponse: state.CarLoan.updateTrancheStatusResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            loanAccountRequest,
            loanTranchesRequest,
            loanApplicationByIdRequest,
            loanApprovalRequestRequest,
            updateTrancheStatusRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TranchesReleaseRequest);
